import { getSafeInsets } from "@/utils/browser";
import { useEffect, useState } from "react";

/**
 * 获取app 安全区域
 * @returns { topSafe: number; bottomSafe: number; }
 */
export const useAppSafearea = () => {
  const [safe, setSafe] = useState({
    topSafe: 0,
    bottomSafe: 0,
  });
  const getSafeInsetsData = async () => {
    try {
      const { topSafe, bottomSafe } = await getSafeInsets();
      setSafe({
        // 减去5px，设计提出太宽了
        topSafe: (topSafe > 0 ? topSafe - 5 : 0) || 0,
        bottomSafe: bottomSafe || 0,
      });
    } catch (error) {
      console.error('Failed to get safe insets:', error);
      // 如果获取安全区域失败，使用默认值
      setSafe({
        topSafe: 0,
        bottomSafe: 0,
      });
    }
  };
  useEffect(() => {
    getSafeInsetsData();
  }, []);
  return {
    topSafe: safe.topSafe,
    bottomSafe: safe.bottomSafe,
  };
};